var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-main" },
    [
      _vm._t("top"),
      _vm._v(" "),
      _vm.TitleShow
        ? _c("page-title", {
            attrs: {
              "title-left": _vm.TitleLeft,
              "title-right": _vm.TitleRight
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        _vm._l(_vm.CardList, function(card, name) {
          return _c(
            "transition",
            { key: name, attrs: { name: "slide-fade" } },
            [
              _vm.CardList[name].row > 0
                ? _c("status-card-template", {
                    attrs: {
                      title: _vm.CardList[name].title,
                      cardObject: _vm.CardList[name],
                      "title-show": _vm.TitleShow
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-060341f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-060341f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/student-status-card/components/PageTemplate.vue
// module id = null
// module chunks = 